export const graphPressPunchFormConfig = [
  {
    id: 1,
    graph_label: "On / Off /Idle",
    fields: [
      {
        id: 18,
        label: "On Time",
        required: true,
        meta: [],
      },
      {
        id: 19,
        label: "Off Time",
        required: true,
        meta: [],
      },
      {
        id: 20,
        label: "Idle Time",
        required: true,
        meta: [],
      },
    ],
  },
  {
    graph_label: "Count",
    id: 2,
    fields: [
      {
        id: 21,
        label: "Count",
        required: true,
        meta: [],
      },
    ],
  },
  {
    id: 3,
    graph_label: "Power consumption",
    fields: [
      {
        id: 22,
        label: "Kwh",
        required: false,
        meta: [],
      },
    ],
  },
  {
    id: 4,
    graph_label: "Status",
    fields: [
      {
        id: 23,
        label: "Machine Status",
        required: true,
        meta: [],
      },
      {
        id: 24,
        label: "Supply Status",
        required: false,
        meta: [],
      },
    ],
  },
];
